/* This file is autogenerated, see readme.md for instructions */
import ReleaseNotesSvgIcon from '@bloomreach/banana-theme/icons/release-notes.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ReleaseNotesIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ReleaseNotesSvgIcon />
    </Icon>
  );
});

ReleaseNotesIcon.displayName = 'ReleaseNotesIcon';

export default ReleaseNotesIcon;
